<template>
  <b-modal
    id="ModId1"
    ref="modal"
    :title="modalTitle"
    size="lg"
    @ok="sendModalData($event)"
    @cancel="clearModal"
    @hidden="clearModal"
    ok-title="Сохранить"
    ok-variant="success"
    cancel-variant="danger"
    cancel-title="Отменить"
    :no-close-on-backdrop=true
    :ok-disabled="veeErrors.any() || hasEmptyFields || !isFormEdited || $parent.supportCheck"
  >
    <b-container fluid v-if="!loading">
      <div class="modal-spinner">
        <b-spinner variant="secondary" label="Loading..."></b-spinner>
        <strong class="mt-3">Загрузка...</strong>
      </div>
    </b-container>
    <b-form ref="form" @submit.stop.prevent="onSubmit" v-else>
      <b-container fluid>
        <b-row class="upper_info">
          <h5 class="mb-3 mr-auto">Общая информация</h5>
          <b-form-group v-if="hasNoTariffRight() && (modalType === 'edit')"
                        class="inline mr-3 align-items-center"
                        label="Расчет без тарифа"
                        label-class="mf-label mb-0"
                        label-for="no-tariff"
          >
            <b-form-checkbox id="no-tariff"
                             v-model="model.p_is_stop_tariff"
                             switch
                             type="checkbox"
                             class="ml-4"
            >
            </b-form-checkbox>
          </b-form-group>
          <b-form-group v-if="modalType === 'edit'"
                        class="inline align-items-center"
                        label="Приостановить"
                        label-class="mf-label mb-0"
                        label-for="banned-input"
          >
            <b-form-checkbox id="banned-input"
                             v-model="model.p_banned"
                             switch
                             type="checkbox"
                             class="ml-4"
            >
            </b-form-checkbox>
          </b-form-group>
        </b-row>
        <b-row class="pb-3">
          <b-col md="3" class="pl-0">
            <b-form-group
              label="ОПФ *"
              label-for="opf"
              label-class="mf-label"
              :invalid-feedback="getError('opf')"
            >
              <treeselect id="opf"
                          name="opf"
                          :options="selects"
                          v-model="model.p_opf"
                          placeholder="Выбрать..."
                          noResultsText="Ничего не найдено..."
                          :clearable=true
                          label="ОПФ *"
                          data-vv-as="ОПФ"
                          v-validate="{required:true}"
              >
                <div slot="value-label" slot-scope="{ node }">{{ node.raw.label }}</div>
              </treeselect>
            </b-form-group>
          </b-col>
          <b-col md="9" class="pr-0">
            <b-form-group
              label="Наименование *"
              label-for="fullname-input"
              label-class="mf-label"
              :invalid-feedback="getError('fullname-input')"
            >
              <b-form-input
                id="fullname-input"
                name="fullname-input"
                v-validate="modelValidation.fullname"
                data-vv-as="Наименование"
                v-model="model.p_fullname"
                placeholder="Наименование без ОПФ"
                :state="validateState('fullname-input')"
              ></b-form-input>

            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="pb-3">
          <b-col md="3" class="pl-0">
            <b-form-group
              label="ИНН *"
              label-for="inn-input"
              label-class="mf-label"
              :invalid-feedback="getError('inn-input')"
            >
              <b-form-input
                id="inn-input"
                name="inn-input"
                v-validate="modelValidation.inn"
                v-model="model.p_inn"
                data-vv-as="ИНН"
                :disabled="access_status"
                :placeholder="innPlaceholder"
                :state="validateState('inn-input')"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group
              :label="kppData.label"
              label-for="kpp-input"
              label-class="mf-label"
              :invalid-feedback="getError('kpp-input')"
            >
              <b-form-input
                id="kpp-input"
                name="kpp-input"
                data-vv-as="КПП"
                v-validate="kppData.validation"
                v-model="model.p_kpp"
                :disabled="access_status"
                :placeholder="kppData.placeholder"
                :state="validateState('kpp-input')"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group
              label="ID организации"
              label-for="orgId-input"
              label-class="mf-label"
            >
              <b-form-input
                id="orgId-input"
                name="orgId-input"
                v-model="model.p_org_id"
                placeholder="ID организации"
                disabled
              ></b-form-input>
              <b-link class="org-id-add" id="clients-program" v-show="orgIdShow" :disabled="$parent.supportCheck"
                      @click="getDataFromOrg(companyDataFromTable)">Добавить
              </b-link>
              <b-popover
                target="clients-program"
                placement="bottom"
                triggers="click focus"
                custom-class="infodec-popover"
                id="infodec-popover"
              >
                <b-table :items="clientsProgramm"
                         :fields="fields"
                         :busy="busyModalTable"
                         show-empty
                         hover
                         @row-clicked="getOrgId"
                         empty-text="Данные отсутствуют"
                         id="my-table">
                  <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Загрузка...</strong>
                    </div>
                  </template>
                </b-table>
              </b-popover>

            </b-form-group>
          </b-col>
          <b-col v-if="hasSelectBillingTypesRight()" md="3" class="pr-0">
            <b-form-group
              label="Тип биллинга"
              label-for="billing_type"
              label-class="mf-label"
              :invalid-feedback="getError('opf')">
              <b-form-select id="billing_type"
                name="billing_type"
                :options="billingItems"
                v-model="model.p_billing_type_alias">
                  <template #first>
                      <b-form-select-option :value="null" disabled>Тип биллинга</b-form-select-option>
                  </template></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="pb-3">
          <b-col md="6" class="pl-0">
            <b-form-group
              label="Номер договора"
              label-for="contract"
              label-class="mf-label"
              :invalid-feedback="getError('contract')"
            >
              <b-form-input
                id="contract"
                name="contract"
                v-validate="modelValidation.contract"
                v-model="model.p_contract"
                data-vv-as="Номер договора"
                placeholder="Введите номер договора"
                :state="validateState('contract')"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Дата договора"
              label-for="contract-date"
              label-class="mf-label"
              :invalid-feedback="getError('contract-date')"
            >
              <ctk-date-time-picker
                id="contract-date"
                name="contract-date"
                v-model="model.p_contract_date"
                label="Дата договора"
                button-now-translation="Сегодня"
                color="#40b539"
                locale="ru"
                onlyDate
                right
                noLabel
                :custom-shortcuts="customShortcuts"
                format="YYYY-MM-DD"
                formatted="DD.MM.YYYY"
              >
              </ctk-date-time-picker>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <h5 class="my-3">Контакты</h5>
        </b-row>
        <b-row class="pb-3">
          <b-col md="6" class="pl-0">
            <b-form-group
              label="Контактное лицо"
              label-for="contact-person-input"
              label-class="mf-label"
            >
              <b-form-input
                id="contact-person-input"
                v-model="model.p_contact_person"
                placeholder="Контактное лицо"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6" class="pr-0">
            <b-form-group
              label="Город"
              label-for="city-input"
              label-class="mf-label"
            >
              <b-form-input
                id="city-input"
                v-model="model.p_city"
                placeholder="Город"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="pb-3">
          <b-col md="6" class="pl-0">
            <b-form-group
              label="Email"
              label-for="contact-email-input"
              label-class="mf-label"
            >
              <b-form-input
                id="contact-email-input"
                v-model="model.p_contact_email"
                placeholder="Email"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6" class="pr-0">
            <b-form-group
              label="Фактический адрес"
              label-for="contact-address-input"
              label-class="mf-label"
            >
              <b-form-textarea
                id="contact-address-input"
                v-model="model.p_contact_address"
                placeholder="Фактический адрес"
              ></b-form-textarea>
            </b-form-group>
          </b-col>

        </b-row>
        <b-row class="pb-3">
          <b-col md="6" class="pl-0">
            <b-form-group
              label="Телефоны"
              label-for="contact-phones-input"
              label-class="mf-label"
            >
              <b-form-textarea
                id="contact-phones-input"
                v-model="model.p_contact_phones"
                placeholder="Телефоны"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col md="6" class="pr-0">
            <b-form-group
              label="Комментарии"
              label-for="comments-input"
              label-class="mf-label"
            >
              <b-form-textarea
                id="comments-input"
                v-model="model.p_comments"
                placeholder="Дополнительная информация"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
      </b-container>

    </b-form>
  </b-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { validation } from './validation'

import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import CtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

export default {
  name: 'edit-company',
  components: {
    Treeselect,
    CtkDateTimePicker
  },
  mixins: [validation],
  data () {
    return {
      loading: null,
      sendMethod: null,
      companyDataFromTable: null,
      orgIdShow: null,
      model: {
        p_banned: false,
        p_is_stop_tariff: false,
        p_opf: null,
        p_fullname: '',
        p_org_id: null,
        p_inn: '',
        p_kpp: '',
        p_contact_person: '',
        p_city: '',
        p_contact_email: '',
        p_contact_address: '',
        p_contact_phones: '',
        p_comments: '',
        p_contract: '',
        p_contract_date: '',
        p_billing_type_alias: null
      },
      selects: null,
      fields: [
        { key: 'org_id', label: 'ID организации' },
        { key: 'org_name', label: 'Наименование' },
        { key: 'org_address', label: 'Адрес' }
      ],
      modalTitle: '',
      modalType: null,
      customShortcuts: [
        { key: 'thisWeek', label: 'Эта неделя', value: 'isoWeek' },
        { key: 'thisMonth', label: 'Этот месяц', value: 'month' },
        { key: 'thisYear', label: 'Этот год', value: 'year' }
      ],
      access_status: false
    }
  },
  watch: {
    modalParamsCompany () {
      this.model.p_banned = Boolean(this.modalParamsCompany.method_data.p_banned)
      this.model.p_is_stop_tariff = Boolean(this.modalParamsCompany.method_data.p_is_stop_tariff)
      this.model.p_fullname = this.modalParamsCompany.method_data.p_fullname
      this.model.p_org_id = this.modalParamsCompany.method_data.p_org_id
      this.model.p_inn = this.modalParamsCompany.method_data.p_inn
      this.model.p_kpp = this.modalParamsCompany.method_data.p_kpp
      this.model.p_contact_person = this.modalParamsCompany.method_data.p_contact_person
      this.model.p_city = this.modalParamsCompany.method_data.p_city
      this.model.p_contact_email = this.modalParamsCompany.method_data.p_contact_email
      this.model.p_contact_address = this.modalParamsCompany.method_data.p_contact_address
      this.model.p_contact_phones = this.modalParamsCompany.method_data.p_contact_phones
      this.model.p_comments = this.modalParamsCompany.method_data.p_comments
      this.model.p_opf = this.modalParamsCompany.method_data.p_opf
      this.model.p_contract = this.modalParamsCompany.method_data.p_contract
      this.model.p_contract_date = this.modalParamsCompany.method_data.p_contract_date
      this.selects = this.modalParamsCompany.selects.p_opf
      this.model.p_org_id = this.companyDataFromTable.org_id
      this.model.p_billing_type_alias = this.modalParamsCompany.method_data.p_billing_type_alias
    },
    groupDropdowns () {
      this.selects = this.groupDropdowns.p_opf
    }
  },
  computed: {
    innPlaceholder () {
      if (this.model.p_opf === 'ИП') {
        return '12 цифр'
      } else {
        return '10 цифр'
      }
    },
    kppData () {
      if (this.model.p_opf === 'ИП') {
        return {
          placeholder: 'Необязательно',
          label: 'КПП',
          validation: {
            required: false
          }
        }
      } else {
        return {
          placeholder: '9 цифр',
          label: 'КПП *',
          validation: {
            required: true,
            digits: 9
          }
        }
      }
    },
    billingItems () {
      return this.billingTypes?.map(({ alias, caption }) => ({ value: alias, text: caption }))
    },
    ...mapState(
      {
        modalParamsCompany: state => state.groupsUsers.modalParamsCompany,
        billingTypes: state => state.groupsUsers.billingTypes,
        userInfo: state => state.authorization.userInfo,
        groupDropdowns: state => state.groupsUsers.groupDropdowns,
        clientsProgramm: state => state.groupsUsers.clientsProgrammData,
        busyModalTable: state => state.groupsUsers.busyModalTable
      }
    ),
    hasEmptyFields () {
      if (this.model.p_opf === 'ИП') {
        return !this.model.p_opf ||
          !this.model.p_fullname ||
          !this.model.p_inn
      } else {
        return !this.model.p_opf ||
          !this.model.p_fullname ||
          !this.model.p_inn ||
          !this.model.p_kpp
      }
    },
    isFormEdited () {
      let isChanged = false
      if (this.modalType === 'edit') {
        if (this.model.p_banned !== Boolean(this.modalParamsCompany.method_data?.p_banned)) {
          isChanged = true
        }
        if (this.model.p_is_stop_tariff !== Boolean(this.modalParamsCompany.method_data?.p_is_stop_tariff)) {
          isChanged = true
        }
        for (const key in this.model) {
          if (key === 'p_banned' || key === 'p_is_stop_tariff') {
            continue
          } else if (key === 'p_org_id' && this.model.p_org_id !== this.companyDataFromTable.org_id) {
            isChanged = true
          } else if (this.modalParamsCompany?.method_data &&
              key in this.modalParamsCompany.method_data &&
              this.model[key] !== this.modalParamsCompany.method_data[key]) {
            isChanged = true
          }
        }
      } else {
        isChanged = true
      }
      return isChanged
    }
  },
  methods: {
    modalCompany (data) {
      console.log('data ', data)
      this.companyDataFromTable = data
      this.modalType = 'add'
      if (data.add) {
        this.modalTitle = 'Добавление организации'
        this.orgIdShow = false
        this.$root.$emit('bv::show::modal', 'ModId1', event)
        this.getGroupDropdowns(data).then(
          () => {
            this.loading = true
            this.sendMethod = 'create'
          }
        )
      } else {
        if (data.access_status === 'Работает') {
          this.access_status = true
        }
        this.modalTitle = 'Редактирование организации'
        this.modalType = 'edit'
        const innKpp = data.inn_kpp.split('/')
        this.companyDataFromTable.inn = innKpp[0].replace(/\s+/g, '')
        if (innKpp[1] === '') {
          this.companyDataFromTable.kpp = 'none'
        } else {
          this.companyDataFromTable.kpp = innKpp[1].replace(/\s+/g, '')
        }
        this.$root.$emit('bv::show::modal', 'ModId1', event)
        this.getGroupModalParams(data).then(
          () => {
            if (this.model.p_org_id === null) {
              this.orgIdShow = true
            }
            this.modalData = data
            this.loading = true
            this.sendMethod = 'edit'
          }
        )
      }
    },
    sendLogic () {
      if (this.sendMethod === 'create') {
        this.model.p_banned = Number(this.model.p_banned)
        this.model.p_is_stop_tariff = Number(this.model.p_is_stop_tariff)
        this.loading = false
        this.createGroup(this.model).then(
          (response) => {
            this.loading = true
            this.$emit('reloadGroups', response)
            this.$emit('goToFirstPage')
            this.$root.$emit('bv::hide::modal', 'ModId1', event)
          },
          (error) => {
            this.loading = true
            console.log(error)
            this.$root.$emit('bv::hide::modal', 'ModId1', event)
          }
        )
      } else if (this.sendMethod === 'edit') {
        this.model.p_banned = Number(this.model.p_banned)
        this.model.p_is_stop_tariff = Number(this.model.p_is_stop_tariff)
        this.loading = false
        this.editGroup(this.model).then(
          (response) => {
            this.loading = true
            this.$emit('reloadGroups', response)
            this.$root.$emit('bv::hide::modal', 'ModId1', event)
          },
          (error) => {
            this.loading = true
            console.log(error)
            this.$root.$emit('bv::hide::modal', 'ModId1', event)
          }
        )
      }
    },
    sendModalData (event) {
      event.preventDefault()
      // this.onSubmit()
      this.sendLogic()
    },
    clearModal () {
      for (const key in this.model) {
        this.model[key] = null
      }
      this.orgIdShow = null
      this.selects = null
      this.loading = false
      this.sendMethod = null
      this.companyDataFromTable = null
      this.access_status = false
    },
    getOrgId (row, index, event) {
      this.model.p_org_id = row.org_id
      this.$root.$emit('bv::hide::popover')
    },
    hasSelectBillingTypesRight () {
      const hasRights = this.userInfo.rights.filter(item => {
        return item === 'select_billing_types'
      })
      return (hasRights.length > 0)
    },
    hasNoTariffRight () {
      const hasRights = this.userInfo.rights.filter(item => {
        return item === 'no_tariff'
      })
      return (hasRights.length > 0)
    },
    ...mapActions('groupsUsers', [
      'editGroup',
      'createGroup',
      'getGroupDropdowns',
      'getGroupModalParams',
      'getDataFromOrg'
    ])
  }
}
</script>

<style scoped>
  .inline {
    display: inline-flex;
  }

  .upper_info {
    align-items: center;
  }

  .form-control::placeholder {
    font-size: 14px;
    color: #90A4AE;
    line-height: 20px;
  }

  input.form-control {
    font-size: 14px;
    line-height: 20px;
  }

  textarea.form-control {
    font-size: 14px;
    line-height: 20px;
  }

  .org-id-add {
    font-size: 14px;
  }
</style>
